import Input from "components/ui/Input";
import { useBill } from "hooks/bill";

export default function BillTotals({ docType }) {
  const {
    totalQty,
    totalQtyPcs,
    totalGross,
    billHeader,
    handleInputChange,
  } = useBill();

  const isDirectWithoutItem = docType === "CNDN" && billHeader.cndntype === "Direct(Without Item)";

  return (
    <div>
      <div className="w-full border-t border-gray-300" />
      <div className="flex justify-end my-2">
        <div className="flex flex-wrap justify-end gap-x-3 gap-y-2">
          <h2 className="inline-flex items-center font-semibold leading-6 text-base text-gray-900">
            Total:
          </h2>
          {!isDirectWithoutItem && (
            <>
              <div className="flex items-center">
                <label className="flex items-center justify-center h-[40px] text-base font-medium leading-6 text-gray-900 pr-2">
                  QTY:
                </label>
                <div className="flex items-center justify-center">
                  <Input
                    name="qty"
                    value={totalQty}
                    type="number"
                    readOnly
                    isDisabled
                    showLabel={false}
                    autoComplete="qty"
                  />
                </div>
              </div>
              <div className="flex items-center">
                <label className="flex items-center justify-center h-[40px] text-base font-medium leading-6 text-gray-900 pr-2">
                  PCS:
                </label>
                <div className="flex items-center justify-center">
                  <Input
                    name="pcs"
                    value={totalQtyPcs}
                    type="number"
                    readOnly
                    isDisabled
                    showLabel={false}
                    autoComplete="pcs"
                  />
                </div>
              </div>
            </>
          )}
          {["AGENTBILL", "CNDN"].includes(docType) ? (
            <div className="flex items-center">
              <label className="block text-base font-medium leading-6 text-gray-900 pr-1">
                GROSS:
              </label>
              <div className="">
                <Input
                  name="gross"
                  value={isDirectWithoutItem ? (billHeader.grossamt || "") : totalGross}
                  type="number"
                  readOnly={!isDirectWithoutItem}
                  isDisabled={!isDirectWithoutItem}
                  onChange={isDirectWithoutItem ? (e) => handleInputChange("grossamt", e.target.value) : undefined}
                  showLabel={false}
                  autoComplete="gross"
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
